<template>
<div class="filter" data-type="input" :data-id=code>
  <input type="text" :name=code :placeholder=placeholder class="filter-input" v-model="fieldVal" @keyup="onChange">
  <svg class="icon filter-icon"><use xlink:href="#search"></use></svg>
</div>
</template>

<script>
import EventBus from '../utils/event-bus';

export default {
  name: "FilterText",
  data() {
    return {
      isOpen: false,
      fieldVal: ''
    };
  },
  props: {
    code: String,
    placeholder: {
      type: String,
      default: 'Search keywords'
    }
  },
  computed: {
  },
  methods: {

    onChange() {

      EventBus.$emit('FILTER_VAR', this.code, this.fieldVal);

    }

  },
  mounted() {
  }
};
</script>

<style scoped>
</style>